module.exports = require("./bez-TZ");